import React, { useEffect, useState } from "react";

// modal components
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import { useReferChat } from "../../hooks/useCrm";
const initvalue = {
  user_ref_id: null,
  startChatId: null,
};
export const ReferChatModal = ({
  src,
  show,
  handleClose,
  idStartChat,
  refer,
}) => {
  const [form, setForm] = useState(initvalue);
  const { mutateAsync: referChat, isloading } = useReferChat();
  useEffect(() => {
    setForm({ ...form, startChatId: idStartChat });
  }, [idStartChat]);
  const handleReferChat = async (data) => {
    await referChat(data).then(() => setForm(initvalue));
  };
  return (
    <BootstrapModal
      handleClose={handleClose}
      modaltitle="ارجاع چت"
      show={show}
      closebutton={
        <Button onclick={handleClose} style={{ border: "none", width: "40px" }}>
          <CgClose />
        </Button>
      }
      // moreButton={!showCrmButton}
    >
      <div className="row">
        <div className="col-12">
          <SimpleSelect1
            res={refer}
            onChange={(e) => setForm({ ...form, user_ref_id: e.value })}
          />
        </div>
        <div className="row m-0 p-0 mt-3">
          <div className="col-6">
            <Button
              bgColor="#009ef7"
              color="#fff"
              onclick={() => {
                handleReferChat(form);
                handleClose();
              }}
            >
              تایید
            </Button>
          </div>
          <div className="col-6">
            <Button onclick={handleClose} bgColor="#f1416c" color="#fff">
              انصراف
            </Button>
          </div>
        </div>
      </div>
    </BootstrapModal>
  );
};

export default ReferChatModal;
